import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";
import AppContainer from "../Appcontainer";
import { persistor, store } from "../../store/index";
import { Provider } from "react-redux";
import Login from "../../views/pages/Authentication/Login";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import ResetPassword from "../../views/pages/Authentication/ResetPassword";
import ForgotPassword from "../../views/pages/Authentication/ForgetPassword";

// Component to scroll to the top of the page on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// IPChecker component to handle IP restriction logic
const IPChecker = ({ children }) => {
  const [userIP, setUserIP] = useState(null);
  const [isAllowed, setIsAllowed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    // IP address restriction temporarily disabled
    // Original functionality preserved in comments below
    setIsAllowed(true);
    setIsLoading(false);
    
    // This code is preserved but not executed
    /* Original IP check implementation:
    if (process.env.REACT_APP_BASE_ENV === 'development') {
      setIsAllowed(true);
      return;
    }

    setIsLoading(true);
    // Fetch user's public IP address and check if it's allowed
    axios
      .get("https://api.ipify.org?format=json")
      .then((response) => {
        const ip = response.data.ip;
        setUserIP(ip);
        console.log(`Checking if IP ${ip} is allowed...`);
        
        // Check if the IP is allowed using the endpoint
        axios
          .post(`${baseUrl}/api/check-ip-address`, { address: ip })
          .then((checkResponse) => {
            console.log('IP check response:', checkResponse.data);
            if (checkResponse.data && checkResponse.data.exists) {
              setIsAllowed(true);
              console.log(`IP ${ip} is allowed`);
            } else {
              console.log(`IP ${ip} is not allowed`);
            }
            setIsLoading(false);
          })
          .catch((checkError) => {
            console.error("Error checking IP address:", checkError);
            setIsLoading(false);
          });
      })
      .catch((error) => {
        console.error("Error fetching IP:", error);
        setIsLoading(false);
      });
    */
  }, [baseUrl]);

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#f8f9fd'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          border: '5px solid rgba(110, 66, 193, 0.1)',
          borderTopColor: '#6e42c1',
          borderRadius: '50%',
          animation: 'spin 1s infinite linear',
        }}></div>
        <style jsx>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }
  
  // Render "Access Denied" if the user's IP is not allowed
  if (!isAllowed && userIP !== null) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#f8f9fd',
        padding: '20px'
      }}>
        <div style={{
          background: 'white',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          padding: '40px',
          maxWidth: '500px',
          width: '100%',
          textAlign: 'center'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            margin: '0 auto 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(220, 53, 69, 0.1)',
            borderRadius: '50%',
          }}>
            <i className="fa fa-exclamation-triangle" style={{
              fontSize: '30px',
              color: '#dc3545'
            }}></i>
          </div>
          <h1 style={{
            fontSize: '28px',
            color: '#6e42c1',
            marginBottom: '20px'
          }}>Access Denied</h1>
          <p style={{
            fontSize: '16px',
            color: '#666',
            marginBottom: '15px'
          }}>You are not connected to an allowed network.</p>
          <div style={{
            background: '#f8f9fa',
            padding: '10px',
            borderRadius: '5px',
            marginBottom: '20px'
          }}>
            <strong>Your IP:</strong> <span style={{ fontFamily: 'monospace' }}>{userIP}</span>
          </div>
          <p style={{
            fontSize: '14px',
            color: '#888'
          }}>Please contact your administrator for access.</p>
        </div>
      </div>
    );
  }
  
  return children;
};

// Main application router
const AppRouter = () => {
  return (
    <div>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter basename="/">
            <ScrollToTop />
            <IPChecker>
              <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/*" element={<AppContainer />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </IPChecker>
            <ToastContainer />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </div>
  );
};

export default AppRouter;